import { Controller } from "stimulus";

export default class extends Controller {
  static values = { frame: String, placeholder: String };

  connect() {
    if (!this.hasPlaceholderValue) {
      const frame = document.getElementById(this.frameValue);
      if (frame) this.placeholderValue = frame.innerHTML;
    }
  }

  close(event) {
    event.preventDefault();
    const frame = document.getElementById(this.frameValue);
    if (frame) {
      frame.removeAttribute('src');
      frame.innerHTML = this.placeholderValue || '';
    }
  }
}
